import { createAction } from '@reduxjs/toolkit';

import { getFailurePayloadCreator, getPayloadCreator, type Meta } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { AccountsValueChangesPageProps } from './accountsValueChangesTypes';

type AccountsValueChangesPayload = QcsSyncResourcesPayload<AccountsValueChangesPageProps>;
type AccountsValueChangesMeta = Meta<AccountsValueChangesPageProps>;

const getRequestPayloadCreator = (payload?: undefined, meta?: AccountsValueChangesMeta) => ({
  payload,
  meta,
});

export const getAccountsValueChanges = createAction('GET_ACCOUNTS_VALUE_CHANGES', getRequestPayloadCreator);
export const getAccountsValueChangesSuccess = createAction(
  'GET_ACCOUNTS_VALUE_CHANGES_SUCCESS',
  getPayloadCreator<AccountsValueChangesPayload, AccountsValueChangesPageProps>(),
);
export const getAccountsValueChangesFailure = createAction(
  'GET_ACCOUNTS_VALUE_CHANGES_FAILURE',
  getFailurePayloadCreator<unknown, AccountsValueChangesMeta>(),
);
